var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    stroke: "#262626",
    fill: "#262626",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 1C5.0275 1 1 5.0275 1 10C1 14.9725 5.0275 19 10 19C14.9725 19 19 14.9725 19 10C19 5.0275 14.9725 1 10 1ZM10 17.2C6.031 17.2 2.8 13.969 2.8 10C2.8 6.031 6.031 2.8 10 2.8C13.969 2.8 17.2 6.031 17.2 10C17.2 13.969 13.969 17.2 10 17.2Z",
    fill: "",
    strokeWidth: 0
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 5V10.1765L12 13",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/time.bf7fbb81d1d1e64c44dfa48a4effc7a5.svg";
export { ForwardRef as ReactComponent };